if (!customElements.get('v2-tabbed-categories')) {
  class v2TabbedCategories extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
      setTimeout(() => {
        this.tabs = this.querySelectorAll('.cat-tabs li');
        this.activeTab = this.querySelector('.cat-tabs li.active').getAttribute('data-tab');
        this.allSelectors = this.querySelectorAll('[data-tab]');
        this.sliders = this.querySelectorAll('[data-slider]');
        this.tabs.forEach((tab) => {
          tab.addEventListener(
            "click",
            function () {
              tab.classList.add("active");
              this.activeTab = tab.getAttribute("data-tab");
              this.updateTabs();
            }.bind(this)
          );
        })
        this.createSliders();
      }, 100);
    }
    updateTabs(){
      this.allSelectors.forEach((tab) => {
        if(tab.getAttribute('data-tab') == this.activeTab){
          tab.classList.add('active');
        }
        else{
          tab.classList.remove('active');
        }
      });
    }
    createSliders(){
      this.sliders.forEach((slider) => {
        var sSelector = slider.getAttribute("data-slider");
        var slider = tns({
          "autoWidth": false,
          "items": 1,
          "gutter": 15,
          "slideBy":1,
          "mouseDrag": true,
          "swipeAngle": false,
          "container": sSelector,
          "speed": 800,
          "edgePadding": 30,
          "loop": false,
          "autoplay": false,
          "responsive": {
              768: {
              "items": 4,
              "edgePadding": 0,
              "slideBy": 4,
              "gutter": 20
              }
            }
          });
        });
    }
  };

  customElements.define('v2-tabbed-categories', v2TabbedCategories);
}